import { render } from "./OfferingsTag.vue?vue&type=template&id=2b50bf74&scoped=true"
import script from "./OfferingsTag.vue?vue&type=script&lang=js"
export * from "./OfferingsTag.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2b50bf74"

export default script